"use strict";

module.exports = require("./is-implemented")() ? globalThis : require("./implementation");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/ext/global-this/index.js
// module id = ../../../node_modules/ext/global-this/index.js
// module chunks = 1